
import React from "react";
import CommunicationAnalyticsModule from "@/components/admin/communication-hub/CommunicationAnalyticsModule";

const CommunicationAnalyticsManagement: React.FC = () => {
  return <CommunicationAnalyticsModule />;
};

export default CommunicationAnalyticsManagement;
